import { apiFetch } from './client'

interface ServerWishlistItem {
  uuid: string
  normalized_mpn: string
  added_at: string
  slug: string
  display_title: string
  primary_image_url: string | null
  effective_price: string | null
  effective_price_inc_vat: string | null
  stock_status: string
}

export interface WishlistItem {
  uuid: string
  normalizedMpn: string
  addedAt: string
  slug: string
  displayTitle: string
  primaryImageUrl: string | null
  effectivePrice: string | null
  effectivePriceIncVat: string | null
  stockStatus: string
}

function toWishlistItem(s: ServerWishlistItem): WishlistItem {
  return {
    uuid: s.uuid,
    normalizedMpn: s.normalized_mpn,
    addedAt: s.added_at,
    slug: s.slug,
    displayTitle: s.display_title,
    primaryImageUrl: s.primary_image_url ?? null,
    effectivePrice: s.effective_price ?? null,
    effectivePriceIncVat: s.effective_price_inc_vat ?? null,
    stockStatus: s.stock_status,
  }
}

export async function fetchWishlist(): Promise<WishlistItem[]> {
  const res = await apiFetch<{ data: ServerWishlistItem[] }>('/wishlist')
  return res.data.map(toWishlistItem)
}

export async function addToWishlist(normalizedMpn: string): Promise<WishlistItem> {
  const res = await apiFetch<{ data: ServerWishlistItem }>('/wishlist', {
    method: 'POST',
    body: JSON.stringify({ normalizedMpn }),
  })
  return toWishlistItem(res.data)
}

export async function removeFromWishlist(uuid: string): Promise<void> {
  await apiFetch<void>(`/wishlist/${uuid}`, { method: 'DELETE' })
}
